import { useEffect } from "react";
import ProductGrid from "@/components/sections/ProductGrid";
import TrustStrip from "@/components/sections/TrustStrip";
import CompareTable from "@/components/sections/CompareTable";

export default function Products() {
    useEffect(() => {
        document.title = "Signia Styletto IX Models & Prices | signiastylettoix.com";
    }, []);
    return (
        <>
            <section className="pt-24 pb-6 md:pt-36 md:pb-12">
                <div className="container-x max-w-[820px]">
                    <p className="eyebrow">Shop Styletto IX</p>
                    <h1 className="font-serif text-[44px] md:text-[64px] leading-[1.04] mt-3">
                        The complete <span className="italic text-[#003E4D]">Styletto IX range.</span>
                    </h1>
                    <p className="mt-5 text-[16px] md:text-[18px] text-[#4a5568] leading-relaxed">
                        Every Styletto IX device on this page is sourced from HearClear's Signia
                        Certified Partner inventory — full warranty, expert fitting, and a 3-day risk-free trial.
                    </p>
                </div>
            </section>
            <TrustStrip />
            <ProductGrid />
            <CompareTable />
        </>
    );
}
